import GridCell from "../GridCell/GridCell";
import { ReactNode } from "react";

interface GridRowProps {
  children: ReactNode | ReactNode[];
  reverseOrderOn?: "mobile" | "desktop";
}

const GridPresetWideListRightContent = ({
  children,
  reverseOrderOn,
}: GridRowProps) => (
  <GridCell
    reverseOrderOn={reverseOrderOn}
    spanColsDesktop={7}
    spanColsTablet={6}
    spanColsMobile={6}
  >
    {children}
  </GridCell>
);

export default GridPresetWideListRightContent;
